import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { BreadCrumbActions } from '../../../shared/components/breadcrumb/breadcrumb.actions'
import { Observable } from 'rxjs'
import { startWith, take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { configurationOptionSelectors } from '../configuration-option.selectors'
import { configurationOptionActions } from '../configuration-option.actions'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { getBreadCrumb } from 'src/app/shared/components/breadcrumb/breadcrumb.selectors'
@UntilDestroy()
@Component({
  selector: 'configuration-option-overview-settings',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionOverviewSettingsComponent implements OnInit {
  public isLoading$: Observable<boolean>
  public activeTab: string = 'paymentModule.payments'
  public routerlink: string = 'payments'
  public arrayTabMenuObjects: any[] = []
  public moduleConfigs: any
  public isMultiDayEnabled = environment.moduleConfigs?.saleModule?.isActive
    ? environment.moduleConfigs?.saleModule?.multiDayFlow
    : false
  public hasCancellationPolicy = environment.moduleConfigs?.saleModule?.isActive
    ? environment.moduleConfigs?.saleModule?.cancelationPolicy
    : false

  public accessRights = AccessRights
  public operationInternalShow: boolean
  public locationShow: boolean

  constructor(
    private store: Store<AppState>,
    private router: Router,
    public accessRightService: UserAccessRightService
  ) {}

  ngOnInit() {
    this.store.dispatch(configurationOptionActions.initActions())
    this.moduleConfigs = environment.moduleConfigs

    this.isLoading$ = this.store
      .select(configurationOptionSelectors.selectIsLoading)
      .pipe(startWith(false))

    this.accessRightService
      .isAllowedByAccessRight([this.accessRights.OperationInternalEvents_read])
      .pipe(take(1))
      .subscribe((isAllowed) => {
        this.operationInternalShow = isAllowed
          ? this.moduleConfigs.surveyModule.isActive
          : false
      })
    this.accessRightService
      .isAllowedByAccessRight([this.accessRights.Locations_read])
      .pipe(take(1))
      .subscribe((isAllowed) => {
        this.locationShow = isAllowed
          ? this.moduleConfigs.locationModule.isActive
          : false
      })

    this.store
      .select(getBreadCrumb)
      .pipe(untilDestroyed(this))
      .subscribe((breadCrumb) => {
        if (breadCrumb.length == 1) {
          this.router.navigateByUrl('configuration-options/settings/payments')
        }
      })
    this.arrayTabMenuObjects = [
      {
        name: 'payments',
        jsonTranslation: 'paymentModule.payments',
        show: true,
        iconName: 'credit-card'
      },
      {
        name: 'onboarding',
        jsonTranslation: 'general.onboarding',
        show: true,
        iconName: 'house-user'
      },
      {
        name: 'employee',
        jsonTranslation: 'employeeModule.employee',
        show: true,
        iconName: 'users'
      },
      {
        name: 'family',
        jsonTranslation: 'configurationOptionModule.family',
        show: environment.moduleConfigs.familyModule.isActive,
        iconName: 'user-friends'
      },
      {
        name: 'discovery-area',
        jsonTranslation: 'configurationOptionModule.discoveryArea',
        show: true,
        iconName: 'compass'
      },
      {
        name: 'home-page',
        jsonTranslation: 'configurationOptionModule.homePage',
        show: environment.moduleConfigs.configOptionModule.showHomePageSettings,
        iconName: 'home'
      },
      {
        name: 'schedule',
        jsonTranslation: 'general.schedule',
        show: true,
        iconName: 'table'
      },
      {
        name: 'operation-internal-events',
        jsonTranslation: 'operationInternalEventModule.operationInternalEvent',

        show: this.operationInternalShow,
        iconName: 'magic'
      },
      {
        name: 'locations',
        jsonTranslation: 'locationModule.locations',
        show: this.locationShow,
        iconName: 'map-marker-alt'
      },
      {
        name: 'multi-day',
        jsonTranslation: 'bookingModule.multiDay',
        show: this.isMultiDayEnabled,
        iconName: 'calendar-week'
      },
      {
        name: 'cancellation-policies',
        jsonTranslation: 'saleModule.cancellationPolicies',
        show: this.hasCancellationPolicy,
        iconName: 'ban'
      },
      {
        name: 'other',
        jsonTranslation: 'general.other',
        show: true,
        iconName: 'cube'
      },
      {
        name: 'year-calendar',
        jsonTranslation: 'general.yearCalendar',
        show: true,
        iconName: 'calendar-alt'
      }
    ]
    this.store.dispatch(
      BreadCrumbActions.initHistory({
        pageName: 'general.settings',
        url: '/configuration-options/settings/payments',
        titleName: ['general.settings', this.activeTab]
      })
    )
  }

  setActiveTab(tab) {
    this.activeTab = tab
    this.routerlink = tab.split('.').pop()

    this.store.dispatch(
      BreadCrumbActions.addPageToHistory({
        pageName: tab,
        url: this.router.url,
        titleName: ['general.settings', this.activeTab]
      })
    )
    this.store.dispatch(
      BreadCrumbActions.filterBreadCrumb({
        pageName: tab,
        url: this.router.url,
        titleName: ['general.settings']
      })
    )
  }
}
